import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { customTableStyles } from "../../assets/CustomTableStyles";
// import { customTableStylesBook } from "../../assets/CustomTableStylesBook";

import Select from "react-select";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import DatePicker from "react-date-picker";
import CustomDatatableGrid from "../../components/CustomDatatableGrid";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png"; // Update with your logo path

const LibrarianRequest = () => {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const {
    handleSubmit,
    control,
    register,
    setValue,
    trigger,
    watch,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBooks, setSelectedBooks] = useState([]);

  const [studentsData, setStudentsData] = useState([]);
  const [studentId, setStudentId] = useState(null);
  const [classId, setClassId] = useState(null);

  const [classesData, setClassesData] = useState([]);
  const [booksData, setBooksData] = useState([]);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [historyRequests, setHistoryRequests] = useState([]);
  const [genreList, setGenreList] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState(null);
  const selectedClass = watch("centerClassId");

  const [openPickerId, setOpenPickerId] = useState(null);
  const [tempReturnDates, setTempReturnDates] = useState({});

  const [selectedReturnDates, setSelectedReturnDates] = useState({});

  const fetchStudentsByIds = async (userId) => {
    try {
      const response = await get(
        `Student/GetStudentByClassSectionIdAsync?classSectionId=0&userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setStudentsData(response ? response : []);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchStudentsByIds(userId);
    } else {
      setStudentsData([]);
    }
  }, [userId]);

  useEffect(() => {
    if (savedCenterId) {
      const fetchClasses = async () => {
        try {
          const response = await get(
            `CenterClass/GetClassCenterByCenterId?id=${savedCenterId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          setClassesData(response);
        } catch (error) {
          console.error("Error fetching countries:", error);
        }
      };

      fetchClasses();
    }
  }, [savedCenterId, setValue]);

  const getBooksAuthorData = async (genre) => {
    if (!token || !genre) return;
    console.log("genre", `${API_BASE_URL}Books/book-author?genre=${genre}`);
    try {
      const response = await fetch(
        `${API_BASE_URL}Books/book-author?genre=${encodeURIComponent(
          genre
        )}&centerId=${savedCenterId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch books");
      }

      const data = await response.json();
      console.log("Fetched Books:", data);
      setBooksData(data);
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };

  useEffect(() => {
    if (selectedGenre?.value) {
      getBooksAuthorData(selectedGenre.value);
    }
  }, [selectedGenre]);

  useEffect(() => {
    const fetchGenres = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}Books/genres`);
        const data = await response.json();

        const genreOptions = data.map((genre) => ({
          value: genre,
          label: genre,
        }));
        setGenreList(genreOptions);
      } catch (error) {
        console.error("Failed to fetch genres:", error);
      }
    };

    fetchGenres();
  }, []);

  const fetchRequests = async () => {
    try {
      if (!userId) {
        console.error("User ID not found in localStorage");
        return;
      }

      const token = localStorage.getItem("token");

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const pendingRes = await fetch(
        `${API_BASE_URL}BookRequest/requestsummary?centerId=${savedCenterId}`,
        { headers }
      );
      const pendingData = await pendingRes.json();
      console.log("pendingData", pendingData);
      setPendingRequests(pendingData);

      const historyRes = await fetch(
        `${API_BASE_URL}BookRequest/loanedsummary?centerId=${savedCenterId}`,
        { headers }
      );
      const historyData = await historyRes.json();
      setHistoryRequests(historyData);
    } catch (error) {
      console.error("Error fetching book requests:", error);
    }
  };
  useEffect(() => {
    fetchRequests();
  }, [userId]);

  const handleStudentChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "create-option") {
      setValue("studentId", { value: 0, label: selectedOption.label });
      setStudentId(0);
    } else if (actionMeta.action === "clear") {
      setValue("studentId", null);
      setStudentId(null);
    } else {
      setValue("studentId", selectedOption || { value: 0, label: "" });
      setStudentId(selectedOption?.value || null);
    }

    trigger("studentId");
  };

  const handleClassChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "create-option") {
      setValue(`centerClassId`, {
        value: 0,
        label: selectedOption.label,
      });
      setClassId(0);
    } else if (actionMeta.action === "clear") {
      setValue(`centerClassId`, null);
      setClassId(null);
    } else {
      setValue(`centerClassId`, selectedOption || { value: 0, label: "" });
      setClassId(selectedOption?.value || null);
    }
    trigger(`centerClassId`);
  };

  const authorsList = [
    { id: 101, name: "Math" },
    { id: 102, name: "Science" },
    { id: 103, name: "History" },
  ];

  const saveData = async (data) => {
    console.log("here");
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    if (!data.studentId?.value || selectedBooks.length === 0) {
      toast.error("Please select a student and at least one book.");
      return;
    }

    const parentUserId = localStorage.getItem("userId");

    const requests = selectedBooks.map((bookId) => ({
      id: 0,
      studentId: data.studentId.value,
      parentUserId: parseInt(parentUserId),
      bookId: bookId,
      status: "Request in Progress",
      appliedDate: dayjs().format("YYYY-MM-DD"),
      fine: 0,
      createdBy: localStorage.getItem("userId"),
      appliedBy: "Librarian",
    }));
    console.log("request", JSON.stringify(requests));
    try {
      const response = await fetch(`${API_BASE_URL}BookRequest`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requests),
      });

      const result = await response.json();
      if (response.ok) {
        toast.success(result.message || "Book request(s) submitted!");

        reset({
          studentId: null,
        });
        setSelectedBooks([]);

        fetchRequests();
      } else {
        toast.error(response.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error saving book requests:", error);
      toast.error("Error while submitting requests.");
    }
  };

  const filteredData = booksData?.filter((book) =>
    book.bookName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCheckboxChange = (bookId) => {
    if (selectedBooks.includes(bookId)) {
      setSelectedBooks((prev) => prev.filter((id) => id !== bookId));
    } else {
      if (selectedBooks.length >= 4) {
        alert("Only 4 books can be added to the cart!");
        return;
      }
      setSelectedBooks((prev) => [...prev, bookId]);
    }
  };

  const handleReturnCheckboxChange = async (row) => {
    const returnDateString = new Date().toISOString();
    console.log(
      "api",
      `${API_BASE_URL}BookRequest/update-status?id=${row.id}&status=Returned&returnd=${returnDateString}`
    );
    try {
      const response = await fetch(
        `${API_BASE_URL}BookRequest/update-status?id=${row.id}&status=Returned&returnd=${returnDateString}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update status.");
      }
      console.log("clg", response.json());

      toast.success("Book status updated!");
      fetchRequests();
    } catch (error) {
      console.error("Error updating book status:", error);
      toast.error("Failed to update book status.");
    }
  };

  const handleLoanCheckboxChange = async (row) => {
    const returnDate = selectedReturnDates[row.id];
    if (!returnDate) {
      alert("Please select a return date first.");
      return;
    }

    const returnDateString = new Date(returnDate).toISOString();
    console.log(
      "api",
      `${API_BASE_URL}BookRequest/update-status?id=${row.id}&status=Issued&returnd=${returnDateString}`
    );
    try {
      const response = await fetch(
        `${API_BASE_URL}BookRequest/update-status?id=${row.id}&status=Issued&returnd=${returnDateString}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update status.");
      }
      console.log("clg", response.json());

      toast.success("Book status updated!");
      fetchRequests();
    } catch (error) {
      console.error("Error updating book status:", error);
      toast.error("Failed to update book status.");
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "bookName",
        header: "Book Name",
        width: 150,
      },
      {
        accessorKey: "genre",
        header: "Category",
        width: 120,
      },
      {
        accessorKey: "author",
        header: "Author",
      },
      {
        accessorKey: "addToCart",
        header: "Add to Cart",
        size: 100,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <input
            type="checkbox"
            checked={selectedBooks.includes(row.original.id)}
            onChange={() => handleCheckboxChange(row.original.id)}
          />
        ),
      },
    ],
    [selectedBooks]
  );

  const Loanedcolumns = React.useMemo(
    () => [
      {
        accessorKey: "mrt-row-numbers",
        header: "Sr No.",
        enableColumnOrdering: false,
        enableEditing: false, 
        enableSorting: false,
        size: 100,
        Cell: ({ row }) => row.index + 1,
      },
      {
        accessorKey: "appliedBy",
        header: "Applied By",
        Cell: ({ row }) => row.original.appliedBy || "-",
      },
      {
        accessorKey: "studentName",
        header: "Pupil",
        size: 150,
        Cell: ({ row }) => row.original.studentName || "-",
      },
      {
        accessorKey: "yearGroup",
        header: "Year Group",
        Cell: ({ row }) => row.original.yearGroup || "-",
      },
      {
        accessorKey: "appliedDate",
        header: "Applied Date",
        size: 120,
        Cell: ({ row }) => (
          <span>
            {row.original.appliedDate ? dayjs(row.original.appliedDate).format("DD-MM-YYYY") : "-"}
          </span>
        ),
      },
      {
        accessorKey: "bookName",
        header: "Book Name",
        size: 200,
      },
      {
        accessorKey: "author",
        header: "Author",
      },
      {
        accessorKey: "category",
        header: "Category",
      },
      {
        accessorKey: "returnDate",
        header: "To be return",
        Cell: ({ row }) =>(
          <span>
            {row.original.returnDate ? dayjs(row.original.returnDate).format("DD-MM-YYYY") : "-"}
          </span>
        ),
      },
      {
        accessorKey: "actualDate",
        header: "Actual Return Date",
        Cell: ({ row }) => (
          <span>
            {row.original.actualDate ? dayjs(row.original.actualDate).format("DD-MM-YYYY") : "-"}
          </span>
        ),
      },
      {
        accessorKey: "fine",
        header: "Fine (if any)",
        Cell: ({ row }) => <span>{row.original.fine > 0 ? `${row.original.fine}` : "-"}</span>,
      },
      {
        accessorKey: "status",
        header: "Status",
      },
      {
        accessorKey: "returnAction",
        header: "Return",
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <input
            type="checkbox"
            checked={row.original.isReturned || false}
            onChange={() => handleReturnCheckboxChange(row.original)}
            disabled={row.original.status === "Returned"}
          />
        ),
      },
    ],
    []
  );

  const requestedColumns = React.useMemo(
    () => [
      {
        accessorKey: "mrt-row-numbers",
        header: "Sr No.",
        enableColumnOrdering: false,
        enableEditing: false, 
        enableSorting: false,
        size: 100,
        Cell: ({ row }) => row.index + 1,
      },
      {
        accessorKey: "appliedBy",
        header: "Applied By",
        Cell: ({ row }) => row.original.appliedBy || "-",
      },
      {
        accessorKey: "studentName",
        header: "Pupil",
        size: 150,
        Cell: ({ row }) => row.original.studentName || "-",
      },
      {
        accessorKey: "yearGroup",
        header: "Year Group",
        Cell: ({ row }) => row.original.yearGroup || "-",
      },
      {
        accessorKey: "appliedDate",
        header: "Applied Date",
        Cell: ({ row }) => (
          <span>
            {row.original.appliedDate ? dayjs(row.original.appliedDate).format("DD-MM-YYYY") : "-"}
          </span>
        ),
      },
      {
        accessorKey: "bookName",
        header: "Book Name",
        size: 200,
        Cell: ({ row }) => row.original.bookName || "-",
      },
      {
        accessorKey: "author",
        header: "Author",
        Cell: ({ row }) => row.original.author || "-",
      },
      {
        accessorKey: "category",
        header: "Category",
        Cell: ({ row }) => row.original.category || "-",
      },
      {
        accessorKey: "booksAvailable",
        header: "Books Available",
        size: 150,
        Cell: ({ row }) => row.original.booksAvailable ?? "-",
      },
      {
        accessorKey: "issuedDate",
        header: "Issued Date",
        Cell: ({ row }) => (
          <span>
            {row.original.issuedDate ? dayjs(row.original.issuedDate).format("DD-MM-YYYY") : "-"}
          </span>
        ),
      },
      {
        accessorKey: "returnDateInput",
        header: "Return Date",
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
            const today = new Date().toISOString().split("T")[0];
    
            return (
              <input
                type="date"
                min={today}
                value={
                  selectedReturnDates[row.original.id]
                    ? new Date(selectedReturnDates[row.original.id])
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={(e) => {
                  const selectedDate = e.target.value
                    ? new Date(e.target.value)
                    : null;
                  setSelectedReturnDates((prev) => ({
                    ...prev,
                    [row.original.id]: selectedDate,
                  }));
                }}
                style={{
                  padding: "1px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "12px",
                  width: "140px",
                  maxWidth: "100%",
                }}
              />
            );
          },
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 150,
        Cell: ({ row }) => row.original.status || "-", 
      },
      {
        accessorKey: "issueAction",
        header: "Issue",
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <input
            type="checkbox"
            onChange={() => handleLoanCheckboxChange(row.original)}
            disabled={!selectedReturnDates[row.original.id]}
          />
        ),
      },
    ],
    [selectedReturnDates]
  );
  
  const exportLoanedToExcel = () => {
    const dataToExport = historyRequests.map((row, index) => ({
      "Sr No": index + 1,
      "Applied By": row.appliedBy || "-",
      Pupil: row.studentName || "-",
      "Year Group": row.yearGroup || "-",
      "Applied Date": row.appliedDate ? dayjs(row.appliedDate).format("DD-MM-YYYY") : "-",
      "Book Name": row.bookName,
      Author: row.author,
      Category: row.category,
      "To be return": row.returnDate ? dayjs(row.returnDate).format("DD-MM-YYYY") : "-",
      "Actual Return Date": row.actualDate ? dayjs(row.actualDate).format("DD-MM-YYYY") : "-",
      "Fine (if any)": row.fine > 0 ? `${row.fine}` : "-",
      Status: row.status,
    }));
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Loaned Books");
    XLSX.writeFile(workbook, "LoanedBooks.xlsx");
  };

  const loadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = () => resolve(img);
      img.onerror = (e) => reject(e);
    });
  };

  const exportLoanedToPDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const logoWidth = 30;
    const logoHeight = 8;
    const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 10;
    
    const roleIdLoggedIn = localStorage.getItem("roleId");
    const orgLogoPath = localStorage.getItem("organizationLogoPath");
    const centerLogoPath = localStorage.getItem("centerLogoPath");
    const orgLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${orgLogoPath}`;
    const centerLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${centerLogoPath}`;

    let logoToUse = logo; // Default imported logo
    const sidebarLogoUrl =
      roleIdLoggedIn == "2" ? orgLogo : roleIdLoggedIn == "3" ? centerLogo : null;

    if (sidebarLogoUrl) {
      try {
        logoToUse = await loadImage(sidebarLogoUrl);
      } catch (error) {
        console.warn(
          "Failed to load sidebar logo, falling back to default.",
          error
        );
      }
    }

    // doc.addImage(logoToUse, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "Loaned Books List";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = logoY + logoHeight + 10;
    doc.text(title, titleX, titleY);

    const includedColumns = Loanedcolumns.filter(
      (column) => column.accessorKey !== "mrt-row-numbers" && column.accessorKey !== "returnAction"
    );

    const headers = ["Sr No.", ...includedColumns.map((col) => col.header)];

    const bodyData = historyRequests.map((row, index) => {
        return [
          index + 1,
            row.appliedBy || "-",
            row.studentName || "-",
            row.yearGroup || "-",
            row.appliedDate ? dayjs(row.appliedDate).format("DD-MM-YYYY") : "-",
            row.bookName,
            row.author,
            row.category,
            row.returnDate ? dayjs(row.returnDate).format("DD-MM-YYYY") : "-",
            row.actualDate ? dayjs(row.actualDate).format("DD-MM-YYYY") : "-",
            row.fine > 0 ? `${row.fine}` : "-",
            row.status,
        ];
      });

    doc.autoTable({
      head: [headers],
      body: bodyData,
      startY: titleY + 10,
      theme: "striped",
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
      },
    });

    doc.save("LoanedBooksList.pdf");
  };

  const exportRequestedToExcel = () => {
    const dataToExport = pendingRequests.map((row, index) => ({
      "Sr No": index + 1,
      "Applied By": row.appliedBy || "-",
      Pupil: row.studentName || "-",
      "Year Group": row.yearGroup || "-",
      "Applied Date": row.appliedDate ? dayjs(row.appliedDate).format("DD-MM-YYYY") : "-",
      "Book Name": row.bookName || "-",
      Author: row.author || "-",
      Category: row.category || "-",
      "Books Available": row.booksAvailable ?? "-",
      "Issued Date": row.issuedDate ? dayjs(row.issuedDate).format("DD-MM-YYYY") : "-",
      Status: row.status || "-",
    }));
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Requested Books");
    XLSX.writeFile(workbook, "RequestedBooks.xlsx");
  };

  const exportRequestedToPDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const logoWidth = 30;
    const logoHeight = 8;
    const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 10;
    
    const roleIdLoggedIn = localStorage.getItem("roleId");
    const orgLogoPath = localStorage.getItem("organizationLogoPath");
    const centerLogoPath = localStorage.getItem("centerLogoPath");
    const orgLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${orgLogoPath}`;
    const centerLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${centerLogoPath}`;

    let logoToUse = logo; // Default imported logo
    const sidebarLogoUrl =
      roleIdLoggedIn == "2" ? orgLogo : roleIdLoggedIn == "3" ? centerLogo : null;

    if (sidebarLogoUrl) {
      try {
        logoToUse = await loadImage(sidebarLogoUrl);
      } catch (error) {
        console.warn(
          "Failed to load sidebar logo, falling back to default.",
          error
        );
      }
    }

    // doc.addImage(logoToUse, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "Requested Books List";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = logoY + logoHeight + 10;
    doc.text(title, titleX, titleY);

    const includedColumns = requestedColumns.filter(
      (column) => column.accessorKey !== "mrt-row-numbers" && column.accessorKey !== "returnDateInput" && column.accessorKey !== "issueAction"
    );

    const headers = ["Sr No.", ...includedColumns.map((col) => col.header)];

    const bodyData = pendingRequests.map((row, index) => {
        return [
            index + 1,
            row.appliedBy || "-",
            row.studentName || "-",
            row.yearGroup || "-",
            row.appliedDate ? dayjs(row.appliedDate).format("DD-MM-YYYY") : "-",
            row.bookName || "-",
            row.author || "-",
            row.category || "-",
            row.booksAvailable ?? "-",
            row.issuedDate ? dayjs(row.issuedDate).format("DD-MM-YYYY") : "-",
            row.status || "-",
        ];
      });

    doc.autoTable({
      head: [headers],
      body: bodyData,
      startY: titleY + 10,
      theme: "striped",
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
      },
    });

    doc.save("RequestedBooksList.pdf");
  };

  const handleDatePickerToggle = (id) => {
    setOpenPickerId(openPickerId === id ? null : id);
  };

  const handleDateSelect = (id, date) => {
    setTempReturnDates((prev) => ({ ...prev, [id]: date }));
    setOpenPickerId(null);
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading mb-2 fs-7">Library Books Request Form</h2>
      </div>

      <div className="row g-3">
        {/* left half */}
        <div className="col-md-5">
          <div className="card">
            <div className="card-body">
              <form
                className="row g-3 new-form-style"
                onSubmit={handleSubmit(saveData)}
              >
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Select Student<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`studentId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={studentsData.map((student) => ({
                          value: student.id,
                          label: student.studentName,
                        }))}
                        onChange={handleStudentChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.studentId && (
                    <small className="text-danger">
                      {errors.studentId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Year Group<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`centerClassId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classesData.map((classItem) => ({
                          value: classItem.id,
                          label: classItem.name,
                        }))}
                        onChange={handleClassChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                        // isDisabled={true}
                      />
                    )}
                  />
                  {errors.centerClassId && (
                    <small className="text-danger">
                      {errors.centerClassId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Books Category<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="bookCategory"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={genreList}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption);
                          setSelectedGenre(selectedOption);
                        }}
                        value={field.value}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.bookCategory && (
                    <small className="text-danger">
                      {errors.bookCategory.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">Search</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div className="table-container fixed-last-column-table">
                  <CustomDatatableGrid
                    columns={columns}
                    data={filteredData || []}
                    enableSearching={false}
                    enablePagination={false}
                  />
                </div>
                <div className="col-12 mt-3">
                  <button className="btn btn-primary btn-sm" type="submit">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Right half */}
        <div className="col-md-7">
          <div className="card">
            <div className="card-body">
              <h5>Loaned Books</h5>
              <div className="table-container fixed-last-column-table">
                <CustomDatatableGrid
                  columns={Loanedcolumns}
                  data={historyRequests}
                  onExportExcel={exportLoanedToExcel}
                  onExportPDF={exportLoanedToPDF}
                />
              </div>
            </div>
          </div>
          <div className="card mt-3">
            <div className="card-body">
              <h5>Requested Books</h5>
              <div className="table-container fixed-last-column-table">
                <CustomDatatableGrid
                  columns={requestedColumns}
                  data={pendingRequests}
                  onExportExcel={exportRequestedToExcel}
                  onExportPDF={exportRequestedToPDF}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LibrarianRequest;
